import { http } from '../../../utils'

import { AxiosResponse } from 'axios'

export const ActionTypes = {
  GET_SITES_RENT_DATA: 'GET_SITES_RENT_DATA'
}

export const getInvoicesChartData = (startDate?: string, endDate?: string) => {
  let url = '/charts/pvt/site_wise_rent'
  if(startDate && endDate) {
    url = `/charts/pvt/site_wise_rent?start_date=${startDate}&end_date=${endDate}`
  }
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export const getInvoicesChartDataAction = (startDate?: string, endDate?: string) => ({
  type: ActionTypes.GET_SITES_RENT_DATA,
  promise: getInvoicesChartData(startDate, endDate),
})
